<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="ReportForm">
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="row row-sm">
                                            <div class="col-md-8">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/img/dashboard.png"
                                                        class="mh-45px pb-2">
                                                    <p class="mb-1">
                                                        <span class="main-content-label"><b>Marklist</b></span><br>
                                                        <!-- <span class="text-muted card-sub-title mb-0">{{TitleOne}}</span> -->
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix mt-2">
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Exam
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="CoCode"
                                                            formControlName="ShEmId">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="examList"
                                                                (filteredReturn)="filteredListExam =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExam"
                                                                [value]="item.ShEmId" (click)="getClg(item)">
                                                                {{item.EmCode}}-{{item.EmName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                    *ngIf="ReportForm.controls['ShEmId'].touched && ReportForm.controls['ShEmId'].errors?.required">
                                                   Mandatory
                                                </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <mat-select #select55 class="colorblack"
                                                            formControlName="CgCode">
                                                            <mat-select-filter *ngIf="select55.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CgCode"
                                                                >
                                                               {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Regn No</mat-label>
                                                        <input matInput formControlName="RollNo" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-sm-12 prpl">
                                                <button type="submit"
                                                    class="btn sz btn-primary btn-icon-text floatright mt-1"
                                                    (click)="Print()">
                                                    <span style="display: flex; align-items: center;">
                                                        <img width="20" height="20" src="../../assets/img/printer.gif"
                                                            alt="Print Icon" style="margin-right: 5px;">
                                                        Print
                                                    </span>
                                                </button>

                                                <button type="button" (click)="Back()"
                                                    class="btn sz btn-primary btn-icon-text floatright mt-1 fr">
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/turn-left.gif"
                                                            style="margin-right: 5px;">
                                                        Back
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>